import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ActivityRows from './ActivityRows';

type ActivityListProps = {
    title?: string;
    className?: string;
    limit?: number;
};

function ActivityList({
    title,
    className = 'section',
    limit,
}: ActivityListProps) {
    const { t } = useTranslation('home');
    return (
        <section className={className}>
            <div className="section-head">
                <h2>{title ?? t('activity.title')}</h2>
                <Link className="text-button" to="/activity">
                    {t('actions.viewAll')}
                    <RightOutlined />
                </Link>
            </div>
            <ActivityRows limit={limit} />
        </section>
    );
}

export default ActivityList;
